import comp from "./SubHeader";
export default comp;
